import { theme } from '@/config/theme';
import { Box, ThemeProvider } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import { useEffect } from 'react';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';
import { Outlet, useNavigate } from 'react-router-dom';
import eLinkLogo from '@assets/elink_distribution_ag_logo.svg';
import { AnnouncementsHost } from '@components/announcements/announcements-host.component.tsx';

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export function AuthLayout() {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          bgcolor: '#f5f6f8',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          px: 2,
          pt: { xs: 10, sm: 14 },
          pb: 6,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40'%3E%3Cpath d='M0 0h40v40H0z' fill='none' stroke='rgba(2,52,76,0.12)' stroke-width='0.5'/%3E%3C/svg%3E")`,
            maskImage:
              'radial-gradient(ellipse 60% 50% at 50% 40%, black 0%, transparent 85%)',
            WebkitMaskImage:
              'radial-gradient(ellipse 60% 50% at 50% 40%, black 0%, transparent 85%)',
            pointerEvents: 'none',
          }}
        />

        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 420,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              mb: 5,
              opacity: 0,
              animation: `${fadeIn} 0.5s ease-out 0ms forwards`,
            }}
          >
            <img
              src={eLinkLogo}
              alt="eLink Distribution AG"
              style={{ height: 36 }}
            />
          </Box>

          <Box
            sx={{
              width: '100%',
              opacity: 0,
              animation: `${fadeIn} 0.5s ease-out 100ms forwards`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box sx={{ width: '100%', mb: 2 }}>
              <AnnouncementsHost placement="LOGIN" />
            </Box>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
